import React from 'react'

import { branch } from 'baobab-react/higher-order'
import getNewIcon from 'utils/getNewIcon'
import { MENU_ITEMS } from 'components/utils/constants/MenuItems'
import { PROFILE_MENU_ITEMS } from 'components/utils/constants/ProfileMenuItems'
import triggerEvent from 'utils/dataLayer'

import Badge from 'components/atoms/Badge'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography/Typography'

import config from 'config'

const { assets_url: assetsUrl } = config

const MobileFullscreenMenu = ({ source, currentUser }) => {
  const PROFILE_UNAUTHORIZED_MENU_ITEMS = [
    {
      url: '/signup',
      name: 'Daftar',
      label: 'signup',
    },
    {
      url: '/signin',
      name: 'Masuk',
      label: 'signin',
    },
  ]
  const PROFILE_AUTHORIZED_MENU_ITEMS = [
    {
      url: '/profile',
      imageUrl: 'assets/img/avatar.png',
      name: (currentUser && currentUser.first_name) || '',
      label: 'profile',
    },
    ...PROFILE_MENU_ITEMS,
  ]

  const items = () => {
    switch (source) {
      case 'directory':
        return MENU_ITEMS
      case 'profileAuthorized':
        return PROFILE_AUTHORIZED_MENU_ITEMS
      case 'profileUnauthorized':
        return PROFILE_UNAUTHORIZED_MENU_ITEMS
      default:
        return null
    }
  }
  return (
    <div className="directory-menu">
      {
        items().map((item, idx) => {
          let Wrapper = 'div'
          let href = {}
          if (item.url) {
            Wrapper = 'a'
            href = { href: item.url }
          }
          return (
            <div className="directory-menu-item" key={`dir-itm-${idx}`}>
              <Wrapper className="directory-menu-item-wrapper" onClick={() => triggerEvent(`ga/global/button-navbar/${item.label}`)} {...href}>
                <Container next>
                  <div className="directory-menu-item-content">
                    <div className="directory-menu-item-nav">
                      {item.icon}
                      {!item.iconName && item.imageUrl && (
                        <img src={`${assetsUrl}/${item.imageUrl}`} alt="Profile Avatar Icon" />
                      )}
                    </div>
                    <Typography variant="subbody" component="p">
                      {item.name}
                    </Typography>
                    {item.isNew && <Badge variant="red">BARU</Badge>}
                    {getNewIcon('right')}
                  </div>
                </Container>
              </Wrapper>
            </div>
          )
        })
      }
      <style jsx>
        {`
          .directory {
            &-menu {
              position: fixed;
              height: 100vh;
              width: 100vw;
              background: #fff;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 98;
              padding-top: 64px;
              overflow: scroll;
              @media screen and (min-width: 768px) {
                display: none;
              }
            }
            &-menu-item {
              display: flex;
              align-items: center;
              padding: 12px 0;
              justify-content: flex-start;
              width: 100%;
              border-bottom: solid 1px #D3DCE6;
            }
            &-menu-item-wrapper {
              display: block;
              width: 100%;
            }
            &-menu-item-content {
              display: flex;
              align-items: center;
              :global(.cmps-container, p) {
                flex-grow: 1;
              }
              :global(p) {
                line-height: 24px;
                color: #1A344F !important;
              }
              :global(img) {
                width: 24px;
                height: 24px;
              }
              :global(.campus-badge) {
                margin-right: 16px;
              }
            }
            &-menu-item-nav {
              margin-right: 16px;
            }
          }
        `}
      </style>
    </div>
)
}

export { MobileFullscreenMenu }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, MobileFullscreenMenu)

